import React, {Fragment} from 'react';

import {Step2Form} from 'presentation/pages/public/sign-up/components/Forms';

export function Step2() {
	return (
		<Fragment>
			<Step2Form />
		</Fragment>
	);
}
